import { useContext, useEffect } from "react";
import { Context } from "Context";
import Title from "./Title";
import { addPrerender } from "utils/common";

const mainClass = "help-error";

const Error = ({ title, subtitle, image }) => {
	useEffect(() => {
  		addPrerender();
 	}, []);

	const { config } = useContext(Context);
	const imageLocation = `${config.helpAssetsUrl}/images`;
	return (
		<div className={`${mainClass}__container`}>
			<img
				src={`${imageLocation}/error/${image}`}
				title={title}
				alt={title}
				className={`${mainClass}__image`}
				loading="lazy"
			/>
			<Title title={title} subTitle={subtitle} name={mainClass} />
		</div>
	);
};

export default Error;
